'use client';
/**
 * Классическая хэш-функция FNV (Fowler/Noll/Vo) с преобразованием к строке по основанию 36.
 *
 * Оптимальна согласно тестам:
 * https://github.com/bryc/code/blob/master/jshash/hashes/README.md
 * */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _create_for_of_iterator_helper_loose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupported_iterable_to_array(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) {
                return {
                    done: true
                };
            }
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var fnv1aBMr36 = function(value) {
    return fnv1aBM(value).toString(36);
};
/**
 * Классическая хэш-функция FNV (Fowler/Noll/Vo) - "forced avalanche" модификация (Mulvey).
 *
 * Оптимальна согласно тестам:
 * https://github.com/bryc/code/blob/master/jshash/hashes/README.md
 *
 * */ var fnv1aBM = function(value) {
    /*  ' | 0' оптимизация для firefox, удваивает производительность. */ var hash = 2166136261 | 0;
    for(var _iterator = _create_for_of_iterator_helper_loose(value), _step; !(_step = _iterator()).done;){
        var char = _step.value;
        hash = Math.imul(hash ^ char, 16777619);
    }
    hash += hash << 13;
    hash ^= hash >>> 7;
    hash += hash << 3;
    hash ^= hash >>> 17;
    hash += hash << 5;
    return hash >>> 0;
};

export { fnv1aBM, fnv1aBMr36 };
